import ScrollBar from "react-perfect-scrollbar";
import { Card, CardBody, Col } from "reactstrap";
import { Image, LI, UL } from "../../../../AbstractElements";
import { profileScrollData, profileScrollSubTitle } from "../../../../Data/BonusUi/Scrollable";
import { dynamicImage } from "../../../../Utils";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { ProfileScrollableTitle } from "../../../../Utils/Constants";

export default function ProfileScrollable() {
  return (
    <Col xxl={4} md={6}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={ProfileScrollableTitle} subTitle={profileScrollSubTitle} />
        <CardBody>
          <ScrollBar className="scroll-demo scroll-b-none profile-scrollable" style={{ width: "100%", height: "300px" }}>
            <UL>
              {profileScrollData &&
                profileScrollData.map((item, index) => (
                  <LI className="list-group-item-action list-hover-primary" key={index}>
                    <Image className="rounded-circle" src={dynamicImage(`user/${item.image}`)} alt="user" />
                    {item.text}
                  </LI>
                ))}
            </UL>
          </ScrollBar>
        </CardBody>
      </Card>
    </Col>
  );
}
